export const environment = {
  production: window.env.production,
  sparketBridgeHost: window.env.sparketBridgeHost,
  widgetUri: window.env.widgetUri,
  build: 2,
  version: '1.0.1',
};
